export const TYPE_INTERVAL = {
  DAY: 'Día(s)',
  WEEK: 'Semana(s)',
  MONTH: 'Mes(es)',
  YEAR: 'Año(s)'
} as const

export const CATALOG_INTERVAL = [
  { label: TYPE_INTERVAL.DAY, value: 'DAY' }, // 'Día(s)'
  { label: TYPE_INTERVAL.WEEK, value: 'WEEK' }, // 'Semana(s)'
  { label: TYPE_INTERVAL.MONTH, value: 'MONTH' }, // 'Mes(es)'
  { label: TYPE_INTERVAL.YEAR, value: 'YEAR' } // 'Año(s)'
]

export const LABEL_TYPE_INTERVAL = {
  DAY: 'Día(s)',
  WEEK: 'Semana(s)',
  MONTH: 'Mes(es)',
  YEAR: 'Año(s)'
}

export const TYPE_NOTIFICATION = {
  AUTHOR: 'author',
  EDITOR: 'editor',
  ADVISOR: 'advisor',
  PRINCIPAL_OWNER: 'principalOwner',
  ALL_OWNERS: 'allOwners',
  CUSTOM: 'custom'
}

export const LABEL_TYPE_NOTIFICATION = {
  author: 'Autor',
  editor: 'Editor',
  advisor: 'Asesor',
  principalOwner: 'Propietario principal',
  allOwners: 'Todos los propietarios',
  custom: 'Personalizado'
}

export const CATALOG_TYPE_NOTIFICATION = [
  { label: LABEL_TYPE_NOTIFICATION.author, value: TYPE_NOTIFICATION.AUTHOR },
  { label: LABEL_TYPE_NOTIFICATION.advisor, value: TYPE_NOTIFICATION.ADVISOR },
  { label: LABEL_TYPE_NOTIFICATION.principalOwner, value: TYPE_NOTIFICATION.PRINCIPAL_OWNER },
  { label: LABEL_TYPE_NOTIFICATION.allOwners, value: TYPE_NOTIFICATION.ALL_OWNERS },
  { label: LABEL_TYPE_NOTIFICATION.custom, value: TYPE_NOTIFICATION.CUSTOM }
]
